import { MainContainerTheme, mobileSize } from "Themes/Metrics";
import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";
import React, { Component } from "react";

import { AuthenticationSelectors } from "Redux/AuthenticationRedux";
import LoadingIcon from "Components/LoadingIcon";
import { MainHeaderTheme } from "Themes/Fonts";
import { NoExploreData } from "Containers/ExploreContainer";
import SideProject from "Components/SideProject";
import { connect } from "react-redux";
import navRoutes from "Navigation/NavRoutes";
import styled from "styled-components";

const Container = styled(MainContainerTheme)`
  @media ${mobileSize.large} {
    width: 100%;
  }
`;

const Header = styled(MainHeaderTheme)``;

const ProjectContainerStyled = styled.div`
  padding: 20px;
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
`;

class MyProjectsContainer extends Component {
  state = {
    fetchError: false,
    fetching: true,
  };

  async componentDidMount() {
    const {
      getUserProjects,
      userDetails: { id },
    } = this.props;

    const data = id;

    const resolve = {
      onSuccess: () => this.setState({ fetching: false }),
      onFailure: () =>
        this.setState({
          fetchError: true,
        }),
    };

    await getUserProjects(data, resolve);
  }

  renderUserProjects = () => {
    const { userProjects, history } = this.props;

    if (userProjects.length === 0) {
      return (
        <NoExploreData
          text={"Looks like you haven't started any projects yet"}
        />
      );
    }

    return userProjects.map((project, key) => {
      return (
        <SideProject
          showTitle
          showRating
          key={key}
          title={project.projectName}
          onClick={() => history.push(`${navRoutes.editProject}/${project.id}`)}
          icon={project.projectIcon}
          project={project}
        />
      );
    });
  };

  render() {
    const { fetching } = this.state;
    return (
      <Container>
        <Header>Click a project to edit</Header>
        <ProjectContainerStyled>
          {fetching ? (
            <div style={{ margin: "auto" }}>
              <LoadingIcon />
            </div>
          ) : (
            this.renderUserProjects()
          )}
        </ProjectContainerStyled>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userDetails: AuthenticationSelectors.getUserDetails(state),
    userProjects: ProjectSelectors.getUserProjects(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserProjects: (data, resolve) =>
      dispatch(ProjectActions.getUserProjectsRequest(data, resolve)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyProjectsContainer);
